import axiosInstance from "../config/axiosInstance";
import API from "../config/config";

class ActivityLogsService {
  static async getActivityLogs(params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        query.append(key, value);
      }
    });
    const qs = query.toString();
    const url = qs ? `${API.ADMIN.ACTIVITY_LOGS}?${qs}` : API.ADMIN.ACTIVITY_LOGS;
    return axiosInstance.get(url);
  }

  static async getDriverLogs(driverId, params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        query.append(key, value);
      }
    });
    const url = `${API.ADMIN.DRIVER_ACTIVITY_LOGS(driverId)}?${query.toString()}`;
    return axiosInstance.get(url);
  }

  static async getRideLogs(rideId, params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        query.append(key, value);
      }
    });
    const url = `${API.ADMIN.RIDE_ACTIVITY_LOGS(rideId)}?${query.toString()}`;
    return axiosInstance.get(url);
  }

  static async getEmployeeLogs(userId, params = {}) {
    return this.getActivityLogs({
      ...params,
      userId,
    });
  }
}

export default ActivityLogsService;
